module.exports = __webpack_public_path__ + "img/c1d8b19.png";